import { useUsers } from '../../users/data/UsersAPI';
import { THIRTY_SECONDS } from 'shared/constants/NumberConstants';
import { BaseResourceFieldProps } from 'shared/form/ResourceFieldLegacy';
import { DriverDTO } from 'shared/modules/driver/DriverDTO';
import { useDriver } from '../data/DriversAPI';
import { ResourceField } from 'shared/form/ResourceField';

export function DriverField(props: BaseResourceFieldProps<DriverDTO>) {
  const useSelectedOption = (guid: string) =>
    useDriver(guid, { staleTime: THIRTY_SECONDS, refetchOnWindowFocus: false });

  return (
    <ResourceField
      {...props}
      useOptions={useOptions}
      noOptionsText="No drivers found"
      useSelectedOption={useSelectedOption}
      groupBy={(option) =>
        option.status === 'deactivated' ? 'Deactivated' : 'Active'
      }
      getOptionKey={(option) => {
        if ('driver' in option) {
          return option.driver?.guid || option.guid;
        }

        return option.guid;
      }}
      getOptionLabel={(option) => {
        if ('driver' in option) {
          return (
            option.internal_name ||
            option.name ||
            option.email ||
            option.phone_number
          );
        }

        return option.name || option.email;
      }}
    />
  );
}

function useOptions(
  query: string | undefined,
  options?: { enabled?: boolean },
) {
  return useUsers(
    {
      q: !!query && query.length >= 3 ? query : '',
      page_size: 20,
      role_in: 'driver',
      status: 'invited,activated,deactivated',
      ordering: 'name',
    },

    {
      enabled: options?.enabled ?? true,
      staleTime: THIRTY_SECONDS,
      refetchOnWindowFocus: false,
    },
  );
}
